import { m } from "framer-motion";
import { Col } from "react-bootstrap";
import { useState } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import {
  getEOITenders,
  getTotalPages,
} from "../../Store/Publication/eoiTenders";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../Components/Loading";

// Number of items to display per page

function Notification() {
  const [currentPage, setCurrentPage] = useState(1);

  // Handle page change
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  // Fetch API data
  const {
    data: EOITendersData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["EOITendersData", currentPage],
    queryFn: () => getEOITenders(currentPage === 1 ? 0 : 6 * (currentPage - 1)),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
  const { data: totalPagesData, isLoading: isLoadingTotalPages } = useQuery({
    queryKey: ["totalPagesData", currentPage],
    queryFn: () => getTotalPages(),
  });

  if (isLoading || isLoadingTotalPages) return <Loading />;
  if (isError)
    return <div className="text-center mt-10">Failed to load data</div>;

  const tenders = EOITendersData?.data || [];
  const totalPages = totalPagesData?.message;

  return (
    <m.div className="container mt-[200px]">
      <Col xl={8} lg={10} className="text-center w-fit">
        <h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084] -tracking-[1px]">
          Notifications
        </h3>
        <m.div
          className="border-b border-1 w-[40%] border-[#146084]"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />
      </Col>

      {/* Table */}
      {/* Table */}
      <div className="w-full overflow-x-auto">
        <table className="min-w-max w-[100%] border-collapse border-2 border-gray-300 mt-8 rounded-lg shadow-lg">
          <thead className="bg-[#146084] text-white">
            <tr>
              <th className="py-3 px-2 sm:px-4 text-left border-r border-gray-400">
                Name
              </th>
              <th className="py-3 px-2 sm:px-4 text-left border-r border-gray-400">
                File
              </th>
              <th className="py-3 px-2 sm:px-4 text-left border-r border-gray-400">
                Link
              </th>
              <th className="py-3 px-2 sm:px-4 text-left border-r border-gray-400">
                Description
              </th>
              <th className="py-3 px-2 sm:px-4 text-left border-r border-gray-400">
                Published Date
              </th>
              <th className="py-3 px-2 sm:px-4 text-left">Last Date</th>
            </tr>
          </thead>
          <tbody>
            {tenders?.length > 0 ? (
              tenders?.map((notification) => (
                <tr
                  key={notification.id}
                  className="even:bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                >
                  <td className="py-3 px-2 sm:px-4 border-b border-r border-gray-200">
                    {notification.name}
                  </td>
                  <td className="py-3 px-2 sm:px-4 border-b border-r border-gray-200">
                    <a
                      href={`https://kera.enfonoerp.com${notification?.file}`}
                      className="text-blue-600 hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      Download{" "}
                    </a>
                  </td>
                  <td className="py-3 px-2 sm:px-4 border-b border-r border-gray-200">
                    {notification?.url && (
                      <a
                        href={notification?.url}
                        className="text-blue-600 hover:underline break-words"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Apply Now
                      </a>
                    )}
                  </td>
                  <td className="py-3 px-2 sm:px-4 border-b border-r border-gray-200 break-words max-w-xs sm:max-w-md">
                    {notification?.description}
                  </td>
                  <td className="py-3 px-2 sm:px-4 border-b border-r border-gray-200">
                    {notification?.published_date}
                  </td>
                  <td
                    className={`py-3 px-2 sm:px-4 border-b text-center border-gray-200 ${
                      new Date(notification?.last_date) < new Date()
                        ? "text-red-500 text-center font-semibold"
                        : ""
                    }`}
                  >
                    {notification?.last_date}
                    <br />
                    {new Date(notification?.last_date) < new Date()
                      ? "Expired"
                      : ""}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="py-4 text-center text-gray-500">
                  No notifications available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="w-full flex justify-center mt-8 mb-10">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
            size="large"
          />
        </Stack>
      </div>
    </m.div>
  );
}

export default Notification;
